import axios from "./httpService";

export default {
  chatsSearchApi: params => axios.get("/v3/chats", { params }),
  getChatApi: ({ chatId }) => axios.get(`/v3/chats/${chatId}`)
};
